import React, { Component } from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { storeMateria } from '../../actions/MateriasAction'
import Loading from '../../components/Loading'
import CabecalhoInterno from '../../components/CabecalhoInterno'
import ContainerInterno from '../../components/ContainerInterno'
import { Form, Col, Row, Button, Alert } from 'react-bootstrap'
import { Redirect } from "react-router"

class MateriasCreate extends Component {

  state = {
    formNome: '',
    erro: null,
    erroShow: false
  }

  setError = (errorMessage = 'Erro ao tentar criar a matéria.') => {
    this.setState({
      erro: errorMessage,
      erroShow: true
    })
    document.getElementsByClassName('containerInterno')[0].scrollTop = 0
    return false
  }

  formSubmit = (e) => {
    e.preventDefault()
    const { formNome } = this.state
    var errorMessage = ""
    if (!formNome) {
      errorMessage += "* Preencha o nome.<br />"
    }
    if (errorMessage !== "") {
      return this.setError(errorMessage)
    }
    const body = {
      nome: formNome
    }
    this.props.storeMateria(this.props.login.accessToken, body)
  }

  render() {

    const { loadMaterias } = this.props.materias
    const { formNome, erro, erroShow } = this.state
    const { redirectTo } = this.props.redirect

    if (loadMaterias) {
      return (
        <Loading></Loading>
      )
    }
    if (redirectTo) {
      return (
        <Redirect to={redirectTo} />
      )
    }
    return (
      <div>
        <CabecalhoInterno history={this.props.history}>
          <h3>Matérias</h3>
        </CabecalhoInterno>
        <ContainerInterno>
          <Form onSubmit={this.formSubmit}>
            {erro && erroShow ? <Alert variant="danger" onClick={() => this.setState({erroShow: false})} ><div dangerouslySetInnerHTML={{ __html: erro }} /></Alert> : []}
            <Form.Group as={Row} controlId="formNome">
              <Form.Label column sm="1" className="text-right">
                Nome
              </Form.Label>
              <Col sm="11">
                <Form.Control
                  value={formNome}
                  type="text"
                  onChange={e => this.setState({ formNome: e.target.value, erroShow: false })}
                />
              </Col>
            </Form.Group>

            <Form.Group as={Row}>
              <Col sm={{ span: 11, offset: 1 }}>
                <Button type="submit">Criar</Button>
              </Col>
            </Form.Group>

          </Form>
        </ContainerInterno>
      </div>
    )
  }
}

const mapStateToProps = state =>
  ({
    materias: state.materias,
    login: state.login,
    redirect: state.redirect
  })

const mapDispatchToProps = dispatch =>
  bindActionCreators({ storeMateria }, dispatch)

export default connect(mapStateToProps, mapDispatchToProps)(MateriasCreate)